import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const ITextMateTokenizationService = ( createDecorator('textMateTokenizationFeature'));
export { ITextMateTokenizationService };
